import { getProductUrl } from '../../product-list-page/productList';
import productsApiClient from '../../product-list-page/ProductsApiClient';
import { imageZoom } from '../image-zoom';
export function gridProductListing(typeOfProduct, numberOfProducts, categoryId, sortOrder) {
    return {
        latestProducts: [],
        isLoading: true,
        imageZoom: imageZoom(),
        init() {
            productsApiClient.getLatest(numberOfProducts, categoryId, sortOrder)
                .then(products => {
                this.latestProducts = products;
                this.isLoading = false;
            });
        },
        getProductUrl,
    };
}
